import { render, staticRenderFns } from "./AccountsPayableResource.vue?vue&type=template&id=6747da22&"
import script from "./AccountsPayableResource.vue?vue&type=script&lang=js&"
export * from "./AccountsPayableResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports